import React from 'react';
import Card from '../../ui/Card';
const DealerRevenueHeatmap: React.FC = () => {
  const stateData = [{
    state: 'Maharashtra',
    dealers: 78,
    revenue: 485,
    avgRevenue: 6.22,
    growth: 12.5,
    intensity: 100
  }, {
    state: 'Gujarat',
    dealers: 65,
    revenue: 425,
    avgRevenue: 6.54,
    growth: 10.8,
    intensity: 88
  }, {
    state: 'Tamil Nadu',
    dealers: 58,
    revenue: 385,
    avgRevenue: 6.64,
    growth: 9.5,
    intensity: 79
  }, {
    state: 'Karnataka',
    dealers: 52,
    revenue: 342,
    avgRevenue: 6.58,
    growth: 11.2,
    intensity: 71
  }, {
    state: 'Uttar Pradesh',
    dealers: 48,
    revenue: 298,
    avgRevenue: 6.21,
    growth: 8.7,
    intensity: 61
  }, {
    state: 'Delhi NCR',
    dealers: 42,
    revenue: 285,
    avgRevenue: 6.79,
    growth: 13.5,
    intensity: 59
  }, {
    state: 'Rajasthan',
    dealers: 38,
    revenue: 245,
    avgRevenue: 6.45,
    growth: 7.8,
    intensity: 51
  }, {
    state: 'West Bengal',
    dealers: 35,
    revenue: 225,
    avgRevenue: 6.43,
    growth: 6.5,
    intensity: 46
  }, {
    state: 'Telangana',
    dealers: 32,
    revenue: 198,
    avgRevenue: 6.19,
    growth: 9.2,
    intensity: 41
  }, {
    state: 'Punjab',
    dealers: 28,
    revenue: 175,
    avgRevenue: 6.25,
    growth: 5.8,
    intensity: 36
  }, {
    state: 'Madhya Pradesh',
    dealers: 25,
    revenue: 158,
    avgRevenue: 6.32,
    growth: 7.2,
    intensity: 33
  }, {
    state: 'Haryana',
    dealers: 22,
    revenue: 142,
    avgRevenue: 6.45,
    growth: 8.5,
    intensity: 29
  }];
  const getIntensityColor = (intensity: number) => {
    if (intensity >= 90) return 'bg-green-700';
    if (intensity >= 75) return 'bg-green-600';
    if (intensity >= 60) return 'bg-green-500';
    if (intensity >= 45) return 'bg-yellow-500';
    if (intensity >= 30) return 'bg-orange-500';
    return 'bg-red-500';
  };
  const getGrowthColor = (growth: number) => {
    if (growth >= 10) return 'text-green-600';
    if (growth >= 7) return 'text-yellow-600';
    return 'text-orange-600';
  };
  return <Card className="p-6 mb-8" data-id="element-7231">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7232">
        Dealer Revenue Heatmap - State-wise Distribution
      </h3>
      <p className="text-sm text-gray-600 mb-6" data-id="element-7233">
        Revenue concentration and dealer network strength by state
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-7234">
        {stateData.map((state, index) => <div key={index} className={`${getIntensityColor(state.intensity)} rounded-lg p-4 text-white hover:shadow-lg transition-shadow cursor-pointer`} data-id="element-7235">
            <div className="flex items-center justify-between mb-2" data-id="element-7236">
              <h4 className="font-bold text-base" data-id="element-7237">{state.state}</h4>
              <span className="text-xs bg-white bg-opacity-20 px-2 py-1 rounded" data-id="element-7238">
                {state.dealers} dealers
              </span>
            </div>
            <div className="space-y-1" data-id="element-7239">
              <div className="flex items-center justify-between" data-id="element-7240">
                <span className="text-xs opacity-90" data-id="element-7241">Total Revenue</span>
                <span className="font-bold text-sm" data-id="element-7242">₹{state.revenue} Cr</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-7243">
                <span className="text-xs opacity-90" data-id="element-7244">Avg per Dealer</span>
                <span className="font-semibold text-sm" data-id="element-7245">
                  ₹{state.avgRevenue} Cr
                </span>
              </div>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-white border-opacity-20" data-id="element-7246">
                <span className="text-xs opacity-90" data-id="element-7247">Growth YoY</span>
                <span className="font-bold text-sm" data-id="element-7248">+{state.growth}%</span>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-7249">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-7250">
          <div className="text-center" data-id="element-7251">
            <div className="text-gray-600 text-sm" data-id="element-7252">Total States</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-7253">12</div>
          </div>
          <div className="text-center" data-id="element-7254">
            <div className="text-gray-600 text-sm" data-id="element-7255">Total Dealers</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-7256">534</div>
          </div>
          <div className="text-center" data-id="element-7257">
            <div className="text-gray-600 text-sm" data-id="element-7258">Total Revenue</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-7259">₹2,960 Cr</div>
          </div>
          <div className="text-center" data-id="element-7260">
            <div className="text-gray-600 text-sm" data-id="element-7261">Avg per State</div>
            <div className="text-2xl font-bold text-blue-600" data-id="element-7262">₹246.7 Cr</div>
          </div>
          <div className="text-center" data-id="element-7263">
            <div className="text-gray-600 text-sm" data-id="element-7264">Avg Growth</div>
            <div className="text-2xl font-bold text-green-600" data-id="element-7265">9.2%</div>
          </div>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-center space-x-6 text-xs" data-id="element-7266">
        <div className="flex items-center" data-id="element-7267">
          <div className="w-4 h-4 bg-green-700 rounded mr-2" data-id="element-7268" />
          <span className="text-gray-600" data-id="element-7269">≥90% intensity</span>
        </div>
        <div className="flex items-center" data-id="element-7270">
          <div className="w-4 h-4 bg-green-500 rounded mr-2" data-id="element-7271" />
          <span className="text-gray-600" data-id="element-7272">60-89%</span>
        </div>
        <div className="flex items-center" data-id="element-7273">
          <div className="w-4 h-4 bg-yellow-500 rounded mr-2" data-id="element-7274" />
          <span className="text-gray-600" data-id="element-7275">45-59%</span>
        </div>
        <div className="flex items-center" data-id="element-7276">
          <div className="w-4 h-4 bg-orange-500 rounded mr-2" data-id="element-7277" />
          <span className="text-gray-600" data-id="element-7278">&lt;45%</span>
        </div>
      </div>
    </Card>;
};
export default DealerRevenueHeatmap;